export const URIS_AS_TITLES = {
  USER: 'User',
  DASHBOARD: 'Dashboard',
  FEED: 'Feed',
  POSTS: 'Posts',
  DIRECT_MESSAGES: 'Direct Messages',
  REPLIES: 'Replies',
  STORIES: 'Stories',
  SETTINGS: 'Settings',
};
